import pako from 'pako';

const GZIP_HEADERS = {
  'content-encoding': 'gzip',
};

/**
 * Compresses `data` via GZip if the data is >= 1000 bytes.
 *
 * Returns a blob and the headers that should be used for the request.
 *
 * @param {string} data
 * @returns {Promise<{body: Blob, headers: Record<string, any>}>}
 */
export const gzipIfNeeded = async (data) => {
  // Return the original data if it is less than 1000 bytes.
  if (data.length < 1000) {
    return {
      body: new Blob([data]),
      headers: {}, // No headers needed since no compression.
    };
  }

  // Fall back on "sync" Pako lib if CompressionStream is not supported by this browser
  if (!('CompressionStream' in window)) {
    return {
      body: new Blob([pako.gzip(data)]),
      headers: GZIP_HEADERS,
    };
  }

  // Convert the input string into a stream
  const stream = new Blob([data], {
    type: 'application/json',
  }).stream();
  // Pipe the stream through the gzip compressor
  const compressedReadableStream = stream.pipeThrough(
    new window.CompressionStream('gzip'),
  );
  // Convert output into a Response
  const compressedResponse = await new Response(compressedReadableStream);
  // Convert the Response into a blob
  const blob = await compressedResponse.blob();
  return {
    body: blob,
    headers: GZIP_HEADERS,
  };
};
